{
  "version": 1,
  "asset_id": "3adc1892-f2a7-4916-8000-f493e82bb928",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/3adc1892-f2a7-4916-8000-f493e82bb928/gallery-9.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/3adc1892-f2a7-4916-8000-f493e82bb928/gallery-9.jpeg",
  "original_filename": "gallery-9.jpeg",
  "size": 1035255,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:37Z"
}
